/**
 * Convert string into lower case.
 * @memberof module:stringcase/lib
 * @function lowercase
 * @param {string} str - String to convert.
 * @returns {string} Lowercase case string.
 */
'use strict';
/** @lends lowercase */

function lowercase(str) {
  str = String(str);

  if (!str) {
    return str;
  }

  return str.toLowerCase();
}
/**
 * Checks whether the string are lowercase.
 * @memberof module:stringcase/lib
 * @function lowercase.isLowercase
 * @param {string} str - String to check
 * @returns {boolean} - True if the string are lowercase.
 */


lowercase.isLowercase = function (str) {
  return str && !/[A-Z]+/.test(str);
};

module.exports = lowercase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvd2VyY2FzZS5qcyJdLCJuYW1lcyI6WyJsb3dlcmNhc2UiLCJzdHIiLCJTdHJpbmciLCJ0b0xvd2VyQ2FzZSIsImlzTG93ZXJjYXNlIiwidGVzdCIsIm1vZHVsZSIsImV4cG9ydHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7O0FBUUE7QUFFQTs7QUFDQSxTQUFTQSxTQUFULENBQW9CQyxHQUFwQixFQUF5QjtBQUN2QkEsRUFBQUEsR0FBRyxHQUFHQyxNQUFNLENBQUNELEdBQUQsQ0FBWjs7QUFDQSxNQUFJLENBQUNBLEdBQUwsRUFBVTtBQUNSLFdBQU9BLEdBQVA7QUFDRDs7QUFDRCxTQUFPQSxHQUFHLENBQUNFLFdBQUosRUFBUDtBQUNEO0FBRUQ7Ozs7Ozs7OztBQU9BSCxTQUFTLENBQUNJLFdBQVYsR0FBd0IsVUFBVUgsR0FBVixFQUFlO0FBQ3JDLFNBQU9BLEdBQUcsSUFBSSxDQUFDLFNBQVNJLElBQVQsQ0FBY0osR0FBZCxDQUFmO0FBQ0QsQ0FGRDs7QUFJQUssTUFBTSxDQUFDQyxPQUFQLEdBQWlCUCxTQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gbG93ZXIgY2FzZS5cbiAqIEBtZW1iZXJvZiBtb2R1bGU6c3RyaW5nY2FzZS9saWJcbiAqIEBmdW5jdGlvbiBsb3dlcmNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IExvd2VyY2FzZSBjYXNlIHN0cmluZy5cbiAqL1xuXG4ndXNlIHN0cmljdCdcblxuLyoqIEBsZW5kcyBsb3dlcmNhc2UgKi9cbmZ1bmN0aW9uIGxvd2VyY2FzZSAoc3RyKSB7XG4gIHN0ciA9IFN0cmluZyhzdHIpXG4gIGlmICghc3RyKSB7XG4gICAgcmV0dXJuIHN0clxuICB9XG4gIHJldHVybiBzdHIudG9Mb3dlckNhc2UoKVxufVxuXG4vKipcbiAqIENoZWNrcyB3aGV0aGVyIHRoZSBzdHJpbmcgYXJlIGxvd2VyY2FzZS5cbiAqIEBtZW1iZXJvZiBtb2R1bGU6c3RyaW5nY2FzZS9saWJcbiAqIEBmdW5jdGlvbiBsb3dlcmNhc2UuaXNMb3dlcmNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY2hlY2tcbiAqIEByZXR1cm5zIHtib29sZWFufSAtIFRydWUgaWYgdGhlIHN0cmluZyBhcmUgbG93ZXJjYXNlLlxuICovXG5sb3dlcmNhc2UuaXNMb3dlcmNhc2UgPSBmdW5jdGlvbiAoc3RyKSB7XG4gIHJldHVybiBzdHIgJiYgIS9bQS1aXSsvLnRlc3Qoc3RyKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IGxvd2VyY2FzZTsiXX0=